export class MultiPaymentData {
    clientEmail: string;
    clientName: string;
    clientLastName: string;
    paymentDTO: MultiMethodPaymentDTO;
    payer: MultiMethodPayer;
    brandCode: string;
    issuerId: string;
    languageTextLocale: string;
    subscribe: boolean;
    transactionUtmDTO: any;
    travellerLastName: string;
    travellerName: string;

    constructor(form: any, sameData?: boolean) {
        if (sameData) {
            this.clientEmail = form.get("payerData").get("emails").get("email").value;
            this.clientName = form.get("payerData").get("payerName").value;
            this.clientLastName = form.get("payerData").get("payerLastName").value;
            this.travellerLastName = form.get("payerData").get("payerLastName").value;
            this.travellerName = form.get("payerData").get("payerName").value;
        } else {
            this.clientEmail = form.get("payerData").get("travellerEmails").get("email").value;
            this.clientName = form.get("payerData").get("travellerName").value;
            this.clientLastName = form.get("payerData").get("travellerLastName").value;
            this.travellerLastName = form.get("payerData").get("travellerLastName").value;
            this.travellerName = form.get("payerData").get("travellerName").value;
        }
        this.subscribe = form.get("paymentSummary").get("subscribe").value;

        this.payer = new MultiMethodPayer;
        this.payer.name = form.get("payerData").get("payerName").value;
        this.payer.lastName = form.get("payerData").get("payerLastName").value;
        this.payer.email = form.get("payerData").get("emails").get("email").value;
        this.payer.country.id = form.get("payerData").get("payerCountry").value.id;
    }

}

export class MultiMethodPaymentDTO {
    amount: number;
    coupon: any;
}

export class MultiMethodPayer {
    name: string;
    lastName: string;
    email: string;
    country: any = {};
}